import { useCallback } from 'react';
import { useAuth } from '@/contexts/AuthContext';

interface RazorpayOptions {
  razorpayOrderId: string;
  amount: number;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  orderId: string;
  onSuccess: (response: RazorpaySuccessResponse) => void;
  onFailure: (error: any, reason?: string) => void;
}

interface RazorpaySuccessResponse {
  razorpay_order_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}

declare global {
  interface Window {
    Razorpay: any;
  }
}

export const useRazorpay = () => {
  const { user } = useAuth();
  
  const openRazorpay = useCallback(
    ({
      razorpayOrderId,
      amount,
      customerName,
      customerEmail,
      customerPhone,
      orderId,
      onSuccess,
      onFailure,
    }: RazorpayOptions) => {
      if (!window.Razorpay) {
        console.error('Razorpay SDK not loaded');
        onFailure(new Error('Razorpay SDK not loaded'), 'SDK not loaded');
        return;
      }

      const options = {
        key: import.meta.env.VITE_RAZORPAY_KEY_ID, // Add to .env
        amount: amount,
        currency: 'INR',
        name: 'BookMyBook',
        description: 'Book Purchase',
        order_id: razorpayOrderId,
        prefill: {
          name: customerName,
          email: customerEmail,
          contact: customerPhone,
        },
        theme: {
          color: '#A8523A', // Your primary color
        },
        handler: function (response: RazorpaySuccessResponse) {
          onSuccess(response);
        },
        modal: {
          ondismiss: function () {
            console.log('Payment modal dismissed by user');
            onFailure(new Error('Payment cancelled by user'), 'Payment cancelled by user');
          },
        },
      };

      const razorpayInstance = new window.Razorpay(options);
      razorpayInstance.on('payment.failed', function (response: any) {
        console.log('Payment failed:', response);
        const errorMessage = response.error?.description || response.error?.reason || 'Payment failed';
        onFailure(response.error, errorMessage);
      });
      razorpayInstance.open();
    },
    [user]
  );

  return { openRazorpay };
};